const CryptoJS = require('crypto-js'); // 引用AES源码js
import { LOGINKEY } from './config.js';

/*
 ** 获取密钥 key
 ** @params token 登录token
 ** @params time  请求时间戳
 */
export function GenerateKey(token, time) {
  let key = token ? token : time;
  return EncryptMd5(key + LOGINKEY).substring(0, 16);
}

/*
 ** 加密方法
 ** @params data 需要加密的明文P
 ** @params key  密钥K
 */
export function Encrypt(data, key) {
  // 从UTF8编码解析出原始字符串
  let srcs = CryptoJS.enc.Utf8.parse(data);
  key = CryptoJS.enc.Utf8.parse(key);
  let options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  };
  let encrypted = CryptoJS.AES.encrypt(srcs, key, options);
  return encrypted.toString();
}

/*
 ** 解密方法
 ** @params word 密文C
 ** @params key  密钥K
 */
export function Decrypt(word, key) {
  key = CryptoJS.enc.Utf8.parse(key);
  let options = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  };
  let decrypt = CryptoJS.AES.decrypt(word, key, options);
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

// MD5 加密
export function EncryptMd5(word) {
  return CryptoJS.MD5(word).toString();
}
